import { AppOption } from '@agilize/components-core/dist/components/menuApps/MenuApps.types';

export interface MainHeaderProps {
  activeMenu: boolean;
  toggleMenu: () => void;
}

export type Apps = 'rh' | 'contabil';

export type AppOptions = {
  [key in Apps]: AppOption;
};

export enum USER_OPTIONS {
  LOGOUT = 'logout',
  PROFILE = 'profile',
}
